const permissions = {
  header: 'Rollen und Berechtigungen',
  notice: 'Änderungen wirken sich auf Benutzer mit übereinstimmenden Rollen auf alle Unternehmensbereiche aus.',
  toast: {
    delete: 'Rolle gelöscht und erfolgreich zugewiesen',
    error: 'Etwas stimmte nicht',
  },
  actions: {
    save: {
      button: 'Änderungen speichern',
      confirmModal: {
        title: 'Bestätigung',
        content: 'Möchten Sie die Änderungen wirklich speichern?',
        confirm: 'Bestätigen',
      },
      error: 'Beim Aktualisieren der Berechtigungen ist ein Fehler aufgetreten.',
      success: 'Berechtigungen erfolgreich aktualisiert!',
    },
    search: {
      placeholder: 'SuchenÉ',
    },

    delete: {
      deleteBtn: 'Löschen',
    },
    history: {
      historyBtn: 'Geschichte',
    },
  },
  roleCard: {
    actions: {
      default: {
        label: 'Standard',
        title: 'Restore Default Permissions for "{{ name }}" Role',
        text: 'you will revert to the default role permissions, resulting in the loss of all the adjustments you\'ve made.,Wenn Sie fortfahren, kehren Sie zu den Standardrollenberechtigungen zurück, was zum Verlust aller von Ihnen vorgenommenen Anpassungen führt., you will revert to the default role permissions, resulting in the loss of all the adjustments you\'ve made.',
        confirm: 'Bestätigen',
        success: 'Die Standardberechtigungen der Rolle wurden erfolgreich wiederhergestellt.',
        failure: 'Aufgrund eines unerwarteten Fehlers konnten die Rollenberechtigungen nicht wiederhergestellt werden.',
      },
      delete: {
        title: 'Rollen löschen',
        deletionEnabled: 'Sie sind dabei, eine Rolle zu löschen',
        deletionDisabled: 'Rolle mit {{ count }} verbundenen Benutzern kann nicht gelöscht werden. Bitte entfernen Sie Benutzer vor dem Löschen',
      },
    },
    select: {
      all: 'Alle Berechtigungen festlegen',
      none: 'Alle Berechtigungen aufheben',
    },
    count: '{{ count }} Benutzer',
  },
  addRoleCard: {
    title: 'Hinzufügen +',
    createMode: {
      label: 'Name:',
    },
  },
  scope: {
    Holidays: 'Feiertage',
    MissionControl: 'MissionControl',
    Timeline: 'Zeitleiste',
    OnlineDrivers: 'Online Fahrer',
    Reservations: 'Buchung',
    LiveMap: 'Live-Karte',
    Settings: 'Einstellungen',
    SettingsTemplates: 'Einstellungsvorlagen',
    Vehicles: 'Fahrzeuge',
    Trips: 'Fahrten',
    Suppliers: 'Anbieter',
    Shuttles: 'Shuttlebusse',
    Shifts: 'Schichten',
    Services: 'Leistungen',
    'Rollen und Berechtigungen': 'Rollen und Berechtigungen',
    Reports: 'Berichte',
    Rates: 'Preise',
    Profiles: 'Profil',
    Passengers: 'Fahrgäste',
    Parent: 'Eltern',
    Users: 'Benutzer',
    Locations: 'Standorte',
    Integrations: 'Integrationen',
    Fares: 'Tarife',
    ExtraServices: 'Zusatzleistungen',
    Drivers: 'Fahrer',
    DriverShifts: 'Fahrerschichten',
    DataUpload: 'Importieren',
    Export: 'Exportieren',
    CustomRules: 'Benutzerdefinierte Regeln',
    BlacklistCards: 'Blacklist-Karten',
    Automations: 'Automatisierungen',
    Attributes: 'Eigenschaften',
    Areas: 'Zonen',
  },
  sitesViewError: 'Wechseln Sie zu einer Einzelansicht, um auf diese Seite zuzugreifen',
};

export default permissions;
